export interface HelpArticleSuggestionItem {
	id: string
	title: string
	url: string
	linkUrl: string
	icon: string
}

interface ArticleLike {
	id: string
	title: string
	urlName: string
	icon: string
}

// url is the readable slug shown in the picker; linkUrl is the id-based href
// that gets inserted, so the link survives article renames.
export function buildHelpArticleSuggestionItems(
	articles: readonly ArticleLike[],
	portalUrl: string,
): HelpArticleSuggestionItem[] {
	return articles.map((article) => ({
		id: article.id,
		title: article.title,
		url: `${portalUrl}docs/${article.urlName}`,
		linkUrl: `${portalUrl}docs/${article.id}`,
		icon: article.icon,
	}))
}
